export enum BulkContainerStatuses {
  Unopened = 'Ungeöffnet',
  PartiallyProduced = 'Teilweise produziert',
  FullyProduced = 'Vollständig produziert',
  Discarded = 'Entsorgt',
}
